module.exports = __webpack_public_path__ + "static/media/How to add universities in school records.4edc0ccf.png";